import React, {Component} from 'react';
import PropTypes from 'prop-types';

import '../assets/stylesheets/NoResult.scss';

export default class NoResult extends Component {

    static propTypes = {
        message: PropTypes.string
    };

    static defaultProps = {
        message: "Empty."
    };

    render() {
        return (
            <div className="NoResult">
                <p>{this.props.message}</p>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/NoResult.js